import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import PagesRoutes from "./pages.routes";
import mdGeneralPostingGroupRoutes from "./master-data/general-posting-group";
import mdVatPostingGroupRoutes from "./master-data/vat-posting-group";
import mdPostingSetupRoutes from "./master-data/posting-setup";
import mdGeneralLedgerRoutes from "./master-data/general-ledger";
import mdGeneralConfigurationRoutes from "./master-data/general-configuration";
import inventoryRoutes from "./inventory.routes";
import payablesRoutes from "./payables.routes";
import postedDocuments from "./postedDocuments.routes";
import entries from "./entries.routes";
import receivablesRoutes from "./receivables.routes";
import storeRoutes from "./store.routes";
import ledgerRoutes from "./ledger.routes";
import documentFlowRoutes from "./documentFlow.routes";
import reportsRoutes from "./reports.routes";
import Auth from "@/services/Auth";
import config from "@/services/Api-config";
import storage from "@/storage/storage";
import PermissionHelper from "@/permissions/PermissionHelper";
import { PermissionEnum } from "@/permissions/PermissionEnum";
import documentApprovalRoutes from "@/router/document-approval.routes";
import integrationRoutes from "@/router/integration.routes";
import changesLogRoutes from "@/router/changesLog.routes";
import dimensionRoutes from "@/router/dimension.routes";

NProgress.configure({ showSpinner: true });

Vue.use(Router);

export const routes = [
  ...mdGeneralPostingGroupRoutes,
  ...mdVatPostingGroupRoutes,
  ...mdPostingSetupRoutes,
  ...mdGeneralLedgerRoutes,
  ...mdGeneralConfigurationRoutes,
  ...postedDocuments,
  ...entries,
  {
    path: "/master-data/:category?",
    name: "master-data",
    component: () => import("@/pages/masterData/Index.vue")
  },
...inventoryRoutes,
...payablesRoutes,
...storeRoutes,
...receivablesRoutes,
...ledgerRoutes,
...documentFlowRoutes,
...reportsRoutes,
...integrationRoutes,
...changesLogRoutes,
  {
    path: "/",
    redirect: "/dashboard"
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/pages/dashboard/DashboardPage.vue")
  },
  // default template pages
  ...PagesRoutes,
  {
    path: "/blank",
    name: "blank",
    component: () => import("@/pages/BlankPage.vue")
  },
  {
    path: "*",
    name: "error",
    component: () => import("@/pages/error/NotFoundPage.vue"),
    meta: {
      layout: "error"
    }
  },
  {
    path: "/access-denied",
    name: "access-denied",
    component: () => import("@/pages/error/AccessDenied.vue"),
  },
  ...documentApprovalRoutes,
  ...dimensionRoutes,
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL || "/",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.path != from.path) {
    NProgress.start();
  }
  const loggedIn = await Auth.IsLogin();

  if (!loggedIn) {
    const redirectUrl = config.SENTEC_ACCOUNTS_URL+"/sign-in?redirect="+encodeURI(window.location.toString());
    window.location.href=redirectUrl;
  } else {
    const toName = <string>to.name;
    await PermissionHelper.loadPermissionAsync();
    if (["home", "blank", "error", "access-denied"].indexOf(toName) == -1 &&
      !PermissionHelper.canAccess({ type: PermissionEnum.ROUTE, item: to })) {
      return router.push(`access-denied?hotelId=${to.query.hotelId}`);
    } else if (PermissionHelper.isRequireChangePassword()){
      PermissionHelper.removeEncryptedUserInformation();
      window.location.href = `${ config.SENTEC_ACCOUNTS_URL }/my-account/change-password?force=1&next=${ window.location.href }`;
    } else {
      const isAllowedAccess = PermissionHelper.canAccess({ type: PermissionEnum.ROUTE, item: to });
      if (to.path === "/access-denied" && isAllowedAccess) {
        return router.push({ path: "/dashboard", query: { ...to.query } });
      }

      const hotelId = from.query.hotelId;
      let query = {};
      if (hotelId && !to.query.hotelId) {
        query = {
          ...to.query,
          hotelId: hotelId
        };
        return next({ path: to.fullPath, query });
      }
      //console.log(to.path)
      if (!hotelId && to.path !== "/service-worker.js" && (typeof to.query.hotelId == "undefined" || to.query.hotelId == "")){
        console.log(`overriding ${to.path}`);
        // Override current url to prevent double redirection
        const rawListHotel: any = await storage.getItem("my-hotels");
        if (rawListHotel != null){
          const listHotel = rawListHotel.Data;
          if (listHotel != null && listHotel.length > 0){
            console.log(listHotel);
            // Get default hotel
            let queryString = "";
            const defaultHotel: any = listHotel.find((i) => i.default_hotel)?.id;
            const selectedHotel = typeof defaultHotel != "undefined" ? defaultHotel : listHotel[0].id;

            queryString = `?hotelId=${ selectedHotel }`;
            to.query.hotelId = selectedHotel.toString();
            query = {
              ...to.query,
              hotelId: selectedHotel
            };
            const editedPath = to.path + queryString;
            history.pushState(
              {},
              <string>to.name,
              editedPath
            );
            return next({ path: editedPath, query });
          }
        }
      }
      return next();
    }
  }
});

router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
